import { createFlatKey } from '../addresses';
import { importTypes, settingStepFieldKeys } from '../../config/import';

const accountKeys = settingStepFieldKeys[importTypes.personalAccounts];

const flatNotExistMsg = 'Отсутствует данное помещение';

const checkIsFlatExist = ({ data, typeId, name }) => {
  const flatKey = createFlatKey({ typeId, name });
  return Boolean(data[flatKey]);
};

const getProcessAccount =
  ({ flatsByTypeAndName, valid, invalid }) =>
  (account) => {
    const {
      [accountKeys.addressType]: addressTypeId,
      [accountKeys.flat]: addressName,
    } = account;

    const isFlatExist = checkIsFlatExist({
      data: flatsByTypeAndName,
      typeId: addressTypeId,
      name: addressName,
    });

    isFlatExist
      ? valid.push(account)
      : invalid.push({ ...account, errors: flatNotExistMsg });
  };

export const checkAccounts = ({ validationResult, data }) => {
  const valid = [];
  const invalid = validationResult.invalid.slice();

  const processAccount = getProcessAccount({
    flatsByTypeAndName: data.flatsByTypeAndName,
    valid,
    invalid,
  });

  validationResult.valid.forEach(processAccount);

  return { valid, invalid };
};
